import { useEffect, useState } from "react";
import { MODALS } from "../../../store/constants";
import { state } from "../../../store/state";
import type { CustomSettingsWidgetProps } from "..";

const StratumsColorsWidget = ({
	defaultValue,
	onChange,
}: CustomSettingsWidgetProps) => {
	const [defaultValueTyped, setDefaultValueTyped] = useState<
		Record<string, string>
	>({});

	useEffect(() => {
		// @ts-ignore
		setDefaultValueTyped(defaultValue);
	}, [defaultValue]);

	const setStratumColor = (stratum: string, color: string) => {
		const newVal = { ...defaultValueTyped };
		newVal[stratum] = color;
		onChange(newVal);
	};

	return (
		<>
			<div
				className={`flex h-8 w-full items-center justify-start font-bold px-3 py-1 pt-4 text-xs text-black dark:text-font-secondary`}
			>
				Цвет объекта разработки:
			</div>
			{Object.entries(defaultValueTyped).map(([stratum, color]) => (
				<div
					key={stratum}
					className={`flex h-8 w-full items-center justify-between px-3 py-1 pt-3 text-xs text-black dark:text-font-secondary`}
				>
					{state.stratumsLegendTransit[stratum]}:
					<div
						className="flex items-center gap-x-2"
						onClick={() => {
							state.colorPickerData = {
								defaultColor: color,
								defaultAlpha: Number(0xff),
								onApply: (newColor: string, _newAlpha: number) => {
									setStratumColor(stratum, newColor);
									state.modal = null;
								},
								onCancel: () => {
									state.modal = null;
								},
							};
							state.modal = MODALS.COLOR_PICKER;
						}}
					>
						<div
							className={`h-5 w-5 border border-gray-500`}
							style={{ backgroundColor: color }}
						></div>
					</div>
				</div>
			))}
		</>
	);
};

export default StratumsColorsWidget;
